import { useSelector } from 'react-redux';

import { Comment } from '../../../components/Comment';
import { CommentPart } from '../../../components/CommentPart';
import { getAnswerById } from '../../../selectors/answers';
import { getIsQuestionTab } from '../../../selectors/tabs';

interface ICommentContainerProps {
  answerId: string;
}

export function CommentContainer({ answerId }: ICommentContainerProps) {
  const { comment } = useSelector(getAnswerById(answerId));
  const isQuestionTab = useSelector(getIsQuestionTab);

  return (
    <Comment title={comment.type} isQuestion={isQuestionTab}>
      <CommentPart message={comment.text} />
    </Comment>
  );
}
